import React from 'react';
import './TrustSection.css';

const TrustSection = () => {
  const trustItems = [
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      ),
      title: 'Student Data Privacy',
      description: 'Your data is secure and protected with enterprise-grade security measures.'
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
        </svg>
      ),
      title: 'No Third-Party Marketing',
      description: 'We never share your information. No advertisements or paid rankings.'
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      ),
      title: 'Institution-Controlled Communication',
      description: 'Complete control over messaging with ethical, counselling-first approach.'
    }
  ];

  return (
    <section className="section trust-section">
      <div className="container">
        <h2 className="section-title">Data Integrity & Trust</h2>
        <p className="section-subtitle">Your trust is our foundation. We maintain the highest standards of data privacy and ethical practices.</p>

        <div className="trust-grid">
          {trustItems.map((item, index) => (
            <div key={index} className="trust-item">
              <div className="trust-icon">
                {item.icon}
              </div>
              <h3 className="trust-item-title">{item.title}</h3>
              <p className="trust-item-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
